// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NotFoundPage__root--dXaG {
    display: flex;
}

.NotFoundPage__body--H6Fj {
    padding: 24px;
    width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/ui/pages/NotFoundPage/NotFoundPage.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,WAAW;AACf","sourcesContent":[".root {\n    display: flex;\n}\n\n.body {\n    padding: 24px;\n    width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `NotFoundPage__root--dXaG`,
	"body": `NotFoundPage__body--H6Fj`
};
export default ___CSS_LOADER_EXPORT___;
